import Button from "components/Buttons/Button";
import React from "react";

interface IDeactivationConfirmationModalProps {
  onDeActivate: () => void;
  onCancel: () => void;
  isDeactivatingOffer: boolean;
}

const DeactivationConfirmationModal: React.FC<
  IDeactivationConfirmationModalProps
> = ({ onDeActivate, onCancel, isDeactivatingOffer }) => {
  return (
    <div className="flex flex-col h-full flex-1">
      <div className="flex-1 gap-4 flex flex-col mt-4 md:mt-8 items-center m-auto">
        {/* Todo: Replace with some other icon */}
        {/* <Avatar color="orange" customClass={"bg-opacity-20"}>
          <DismissCircle32Filled color="red" className="m-auto" />
        </Avatar> */}
        <div className="font-semibold text-black text-center md:text-xl">
          Are you sure you want to deactivate your business on Open Rewards?
        </div>
        <div className="md:text-sm text-xs text-center">
          Your business will stop being visible on Open Rewards. Customers will
          no longer be able to earn or redeem rewards at your business
        </div>
      </div>
      <div className="flex md:flex-row flex-col  w-full self-center justify-center no-scrollbar">
        <Button
          label={"No, keep it active"}
          onClick={onCancel}
          variant="secondary"
        />
        <Button
          label={"Yes, deactivate"}
          onClick={onDeActivate}
          loading={isDeactivatingOffer}
          customClass="!bg-failed"
        />
      </div>
    </div>
  );
};

export default DeactivationConfirmationModal;
